import React from 'react';

import type { Product } from '../../../shop-builder/types';
import { ProductCard } from './ProductCard';
import './ProductGrid.css';

interface ProductGridProps {
    products: Product[];
    athleteSlug: string | null;
}

export function ProductGrid({ products, athleteSlug }: ProductGridProps) {
    if (products.length === 0) {
        return (
            <div className="ats-product-grid ats-product-grid--empty">
                <p>This shop is just getting started — check back soon.</p>
            </div>
        );
    }

    return (
        <div className="ats-product-grid">
            {products.map((product) => (
                <ProductCard key={product.public_id} product={product} athleteSlug={athleteSlug} />
            ))}
        </div>
    );
}
